<div class="toolbar-primary">
  <mat-toolbar>
    <mat-toolbar-row>
      <div class="mx-auto order-0 text-center w-100">
        <h2 class="font-weight-bold">{{ currentFacility.name }}</h2>
      </div>

      <div class="flex-spacer"></div>

      <div fxLayout="row" fxLayoutAlign="center center">
        <div class="d-flex align-items-center">
          <span class="material-icons">notifications</span>
        </div>

        <div class="ml-4">
          <img src="{{ currentUser.image }}" class="mat-icon-button ml-4" alt="avatar image" height="35" *ngIf="currentUser.image; else NoImage">
          <ng-template #NoImage>
            <div class="mat-icon-button" style="background: #efefef; padding: 5px">
              <mat-icon>person</mat-icon>
            </div>
          </ng-template>
        </div>

        <div class="ml-3" fxLayout="column" fxLayoutAlign="center start">
          <span>{{ currentUser.name }}</span>
          <small class="text-muted" style="line-height: 10px">{{ currentUser.roles }}</small>
        </div>
        <div>
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item><a>Perfil</a></button>
            <button mat-menu-item><a (click)="logout()">Logout</a></button>
          </mat-menu>


          <button mat-icon-button [matMenuTriggerFor]="appMenu">
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</div>